import formatter from '@/mixins/formatter'

export default {

  mixins: [formatter],

  dataNew () {
    return {
      employeeContract: {
        id: null,
        employee_code: null,
        first_name: null,
        middle_name: null,
        last_name: null,
        suffix_name: null,
        unit: null,
        department: null,
        position: null,
        employment_status: null,
        address: null,
        items: [],
        item_details: []
      }
    }
  },
  methods: {

    marginY: (top = 0, bottom = 0) => ({ text: ' ', margin: [0, top, 0, bottom] }),

    pageBreak: (pageBreak = 'after') => ({ text: ' ', pageBreak: pageBreak }),

    createNewContractPDFOptions (options) {
      this.employeeContract = options.employee

      return this.$pdfmake.createPdf(
        {
          pageSize: 'Legal',
          pageMargins: [40, 75, 40, 75],
          info: {
            title: options.info.title,
            author: options.info.author,
            creator: options.info.creator,
            subject: options.info.subject
          },
          defaultStyle: {
            font: 'Lato',
            fontSize: 11,
            alignment: 'justify',
            lineHeight: 1.5
          },
          header: [
            {
              image: 'logo',
              alignment: 'right',
              margin: [0, 30, 18, 0],
              fit: [90, 40]
            }
          ],
          content: [
            this.pageOneNew(),
            this.otherPagesNew()
          ],
          pageBreakBefore: function (currentNode, nodeContainer) {
            return Number(currentNode?.headlineLevel || 0) === 1
          },
          footer: function (currentPage, pageCount) {
            return {
              stack: [
                { canvas: [{ type: 'line', x1: 40, y1: 0, x2: 560, y2: 0, lineHeight: 2, lineWidth: 1, color: 'green' }] },
                { canvas: [{ type: 'line', x1: 40, y1: 0, x2: 560, y2: 0, lineHeight: 2, lineWidth: 1, color: 'green' }] },
                {
                  text: process.env.VUE_APP_COMPANY_TITLE,
                  margin: [40, 10, 0, 0],
                  style: 'footer'
                },
                { text: process.env.VUE_APP_COMPANY_ADDRESS, style: 'footer' },
                {
                  columns: [
                    {
                      text: process.env.VUE_APP_COMPANY_NUMBER
                    },
                    {
                      text: `${currentPage} of ${pageCount}`,
                      alignment: 'right'
                    }
                  ],
                  style: 'footer'
                }
              ]
            }
          },
          images: {
            logo: options.logo ? options.logo : `${window.location.origin}/img/invalid-image.png`,
            invalidImage: `${window.location.origin}/img/invalid-image.png`
          },
          styles: {
            header: {
              margin: [40, 0, 0, 0]
            },
            footer: {
              fontSize: 9,
              margin: [40, 0, 40, 0]
            },
            title: {
              bold: true,
              alignment: 'center',
              fontSize: 12
            },
            subTitle: {
              bold: true,
              margin: [0, 10, 0, 10]
            },
            normalFont: {
              alignment: 'justify'
            }
          }
        },
        null,
        {
          Lato: {
            normal: `${window.location.origin}/assets/lato/Lato-Regular.ttf`,
            bold: `${window.location.origin}/assets/lato/Lato-Bold.ttf`,
            italics: `${window.location.origin}/assets/lato/Lato-Italic.ttf`,
            bolditalics: `${window.location.origin}/assets/lato/Lato-BoldItalic.ttf`
          }
        }
      )
    },

    pageOneNew () {
      return {
        stack: [
          {
            text: [
              'MEMORANDUM OF AGREEMENT'
            ],
            bold: true,
            alignment: 'center'
          },
          {
            text: 'FOR THE ISSUANCE AND CUSTODY OF COMPANY-OWNED DEVICE',
            bold: true,
            alignment: 'center',
            margin: [0, 0, 0, 20]
          },
          {
            text: 'KNOW ALL MEN BY THESE PRESENTS: ',
            margin: [0, 10, 0, 10],
            bold: true
          },
          {
            text: 'This Memorandum of Agreement is made and executed by and between:',
            margin: [0, 0, 0, 10]
          },
          {
            text: [
              {
                text: 'ALJAY AGRO-INDUSTRIAL SOLUTIONS, INC.',
                bold: true
              },
              ', a corporation duly organized and existing under Philippine laws, '
            ],
            alignment: 'justify'
          },
          {
            text: [
              'with office address at Purok Maligaya, Batal, Santiago City ',
              'represented herein by ',
              {
                text: 'Joshua V. Valle, CPA, ',
                bold: true
              },
              'hereinafter referred to as the ',
              {
                text: '“Company”',
                bold: true
              },
              ';'
            ],
            alignment: 'justify'
          },
          {
            text: ' -And- ',
            alignment: 'center',
            margin: [0, 5, 0, 5]
          },
          {
            text: [
              {
                text: this.employeeContract?.suffix_name ? (
                  `${this.employeeContract.first_name} ${this.employeeContract?.middle_name || ''} ${this.employeeContract.last_name} ${this.employeeContract?.suffix_name || ''}`
                ) : (
                  `${this.employeeContract.first_name} ${this.employeeContract?.middle_name || ''} ${this.employeeContract.last_name}`
                ),
                bold: true
              },
              ', a bona fide employee of the COMPANY',
              ', with employment status ',
              {
                text: this.employeeContract.employment_status,
                bold: true
              },
              ', ',
              'holding the position of ',
              {
                text: this.employeeContract.position,
                bold: true
              },
              ' under the ',
              {
                text: this.employeeContract.department,
                bold: true
              },
              ', ',
              {
                text: this.employeeContract.unit,
                bold: true
              },
              ', and residing at ',
              {
                text: this.employeeContract.address,
                bold: true
              },
              ', ',
              {
                text: 'hereinafter referred to as the '
              },
              {
                text: '“CUSTODIAN.”',
                bold: true
              }
            ],
            alignment: 'justify',
            margin: [0, 10, 0, 10]
          },
          {
            text: [
              'The COMPANY and the CUSTODIAN shall collectively be referred to as the ',
              {
                text: '“PARTIES.”',
                bold: true
              }
            ]
          },
          {
            text: 'DEFINITION OF COMPANY-ISSUED IT ASSET',
            bold: true,
            margin: [0, 10, 0, 10]
          },
          {
            text: [
              'For purposes of this Agreement, ', {
                text: '“Company-Issued IT Asset” ',
                bold: true
              },
              'refers to any company-owned ',
              'information technology device, equipment, or related accessory issued to the CUSTODIAN for ',
              'official use, including but not limited to laptop computers, tablets, mobile devices, chargers, ',
              'keyboards, mouse devices, docking stations, bags, adapters, cables, and other related IT equipment.'
            ]
          },
          {
            text: 'WITNESSETH:',
            bold: true,
            alignment: 'center',
            margin: [0, 10, 0, 10]
          },
          {
            alignment: 'justify',
            text: 'WHEREAS, the COMPANY issues certain company-owned IT assets to employees for official business use;',
            margin: [0, 0, 0, 10]
          },
          {
            alignment: 'justify',
            text: [
              'WHEREAS, the Company-Issued IT Asset provides mobility, productivity, and operational ',
              'support to the CUSTODIAN in the performance of his/her work, but shall remain the exclusive property of the COMPANY;'
            ],
            margin: [0, 0, 0, 10]
          },
          {
            alignment: 'justify',
            text: [
              'WHEREAS, the issuance of the Company-Issued IT Asset is based on the CUSTODIAN’s ',
              'current position, employment status, assigned duties, and operational requirements, and may ',
              'be changed, recalled, replaced, or reassessed by the COMPANY when necessary;'
            ],
            margin: [0, 0, 0, 10]
          },
          {
            alignment: 'justify',
            text: [
              'WHEREAS, the PARTIES agree to be bound by the terms and conditions governing the use, ',
              'care, maintenance, return, confidentiality, and accountability of the Company-Issued IT Asset; '
            ],
            margin: [0, 0, 0, 10]
          },
          {
            alignment: 'justify',
            text: [
              'NOW, THEREFORE, for and in consideration of the foregoing premises and the mutual covenants herein contained, the PARTIES hereby agree as follows:'
            ],
            margin: [0, 0, 0, 10]
          }
        ]
      }
    },

    otherPagesNew () {
      return {
        stack: [
          {
            type: 'upper-roman',
            margin: [0, 0, 0, 0],
            ol: [
              this.periodOfUsefulLifeNew(),
              this.issuedAssetsNew(),
              this.rolesAndResponsibilitiesOfTheCustodianNew(),
              this.confidentialityAndDataProtectionObligationsNew(),
              this.warrantyCoverageAndRepairCostsNew(),
              this.repairsNotCoveredByWarrantyNew(),
              this.lossTheftOrDamageNew(),
              this.rolesAndResponsibilitiesOfTheCompanyNew(),
              this.sanctionForTheNegligenceOfCustodianNew(),
              this.returnReassignmentOrReplacementOfCompanyIssuedITAssetNew(),
              this.rescissionOfAgreementNew(),
              this.entireAggreementNew()
            ]
          },
          this.approversNew()
        ]
      }
    },

    periodOfUsefulLifeNew () {
      return {
        stack: [
          {
            text: 'PERIOD OF USEFUL LIFE',
            margin: [0, 10, 0, 0],
            fontSize: 12,
            decoration: 'underline'
          },
          {
            margin: [25, 5, 0, 0],
            type: 'lower-alpha',
            ol: [
              {
                text: [
                  'The minimum useful life of the Company-Issued IT Asset shall be ',
                  {
                    text: 'three (3) years or thirty-six (36) months ',
                    bold: true
                  },
                  'from the date of issuance, unless otherwise determined by the COMPANY based on asset type, condition, specifications, or business requirement.'
                ]
              },
              {
                text: 'The useful life shall be used only as a basis for determining the market value, book value, and applicable accountability in case of loss, theft, damage, or non-return of the Company-Issued IT Asset and/or its accessories.'
              },
              {
                text: [
                  'The IT Department shall assess the performance, condition, usability, and compatibility ',
                  'of the Company-Issued IT Asset during or after its useful life and may recommend ',
                  'repair, upgrade, replacement, reassignment, or retirement of the asset to ensure employee productivity and uninterrupted work operations. '
                ]
              }
            ]
          }
        ]
      }
    },

    issuedAssetsNew () {
      const border = [false, false, false, false]

      const itemsOfEmployee = []
      const itemDetailsOfEmployee = []

      this.employeeContract.items.forEach(item => {
        itemsOfEmployee.push(
          [
            { text: item.item_code, border: border },
            { text: item.category_name, border: border },
            { text: item.serial_number, border: border },
            { text: item.original_cost, border: border, alignment: 'right' }
          ]
        )

        if (item.specifications) {
          itemsOfEmployee.push(
            [
              {
                colSpan: 4,
                text: item.specifications,
                border: [false, false, false, true],
                margin: [0, 0, 0, 10]
              },
              '',
              '',
              ''
            ]
          )
        }
      })

      this.employeeContract.item_details.forEach(item => {
        itemDetailsOfEmployee.push(
          [
            { text: item.item_detail_code, border: border },
            { text: item.category_name, border: border },
            { text: item.serial_number, border: border },
            { text: item.original_cost, border: border, alignment: 'right' }
          ]
        )

        if (item.specifications) {
          itemDetailsOfEmployee.push(
            [
              { colSpan: 2, text: '', border: [false, false, false, true] },
              '',
              {
                colSpan: 2,
                text: item.specifications,
                border: [false, false, false, true],
                margin: [0, 0, 0, 10]
              },
              ''
            ]
          )
        }
      })

      return {
        stack: [
          {
            text: 'ISSUED ASSETS',
            margin: [0, 10, 0, 0],
            fontSize: 12,
            decoration: 'underline'
          },
          {
            margin: [0, 5, 0, 0],
            table: {
              layout: 'headerLineOnly',
              headerRows: 1,
              widths: ['25%', '20%', '35%', '15%'],
              body: [
                [
                  {
                    text: 'Item Code',
                    bold: true,
                    border: [false, false, false, true]
                  },
                  {
                    text: 'Category',
                    bold: true,
                    border: [false, false, false, true]
                  },
                  {
                    text: 'Serial Number',
                    bold: true,
                    border: [false, false, false, true]
                  },
                  {
                    text: 'Cost',
                    bold: true,
                    border: [false, false, false, true],
                    alignment: 'right'
                  }
                ],
                ...itemsOfEmployee.map(row => [row[0], row[1], row[2], row[3]]),
                ...itemDetailsOfEmployee.map(row => [row[0], row[1], row[2], row[3]])
              ]
            }
          }
        ]
      }
    },

    // termsAndConditionsNew () {
    //   return {
    //     stack: [
    //       {
    //         text: 'TERMS AND CONDITIONS',
    //         margin: [0, 10, 0, 0],
    //         decoration: 'underline'
    //       },
    //       {
    //         margin: [25, 5, 0, 0],
    //         type: 'lower-alpha',
    //         ol: [
    //           this.rolesAndResponsibilitiesOfTheCustodianNew(),
    //           this.rolesAndResponsibilitiesOfTheCompanyNew()
    //         ]
    //       }
    //     ]
    //   }
    // },

    rolesAndResponsibilitiesOfTheCustodianNew () {
      return {
        stack: [
          {
            text: 'ROLES AND RESPONSIBILITIES OF THE CUSTODIAN',
            margin: [0, 10, 0, 0],
            decoration: 'underline'
          },
          {
            margin: [25, 5, 55, 0],
            type: 'lower-alpha',
            ol: [
              'The CUSTODIAN shall affix his/her signature on this Agreement as proof of acceptance and acknowledgment of the Company-Issued IT Asset and its accessories.',
              'By signing this Agreement, the CUSTODIAN acknowledges that he/she received the Company-Issued IT Asset and accessories in good working condition, unless otherwise stated in the asset remarks, inspection report, or turnover document.',
              'The Company-Issued IT Asset shall be used strictly for work-related tasks, official business purposes, authorized remote work, and/or professional development activities related to the CUSTODIAN’s role in the COMPANY.',
              'The CUSTODIAN shall use the Company-Issued IT Asset in accordance with all existing and future COMPANY policies, IT policies, information security policies, acceptable use policies, and other related rules and procedures.',
              'The CUSTODIAN shall exercise reasonable care in the use, handling, storage, and safekeeping of the Company-Issued IT Asset and its accessories to prevent unauthorized use, damage, loss, theft, misuse, or exposure to harmful conditions.',
              'The CUSTODIAN shall ensure that the Company-Issued IT Asset is protected at all times by a secure password, lock screen, PIN, biometric security, or other security measures required by the IT Department.',
              'The CUSTODIAN shall safeguard all company data, files, credentials, accounts, business information, and confidential information stored in, processed by, or accessed through the Company-Issued IT Asset.',
              'The CUSTODIAN shall regularly save or back up work-related files through authorized company storage platforms such as Google Drive, approved external storage, or other COMPANY-approved backup systems. The IT Department shall not be responsible for data loss caused by the CUSTODIAN’s failure to follow backup procedures.',
              'The CUSTODIAN shall not install, uninstall, modify, disable, remove, or tamper with any software, application, security tool, system setting, hardware component, device configuration, management profile, or company-installed control without prior approval from the IT Department.',
              'Any unauthorized software installation, hardware modification, tampering, disabling of security features, unauthorized repair, or removal of company management controls shall make the CUSTODIAN liable for any resulting loss of data, system issue, security incident, damage, or voided warranty.',
              'In case of system error, hardware issue, software issue, required modification, repair, or need for technical assistance, the CUSTODIAN shall immediately file a request through the IT Ticketing System or the official IT support channel.',
              'The CUSTODIAN shall surrender the Company-Issued IT Asset to the IT Department when required for scheduled maintenance, inspection, security updates, inventory validation, system upgrades, repair, or audit.',
              'The CUSTODIAN shall not lend, transfer, assign, or allow another person to use the Company-Issued IT Asset except under the following conditions:',
              {
                margin: [25, 5, 0, 0],
                type: 'lower-roman',
                ol: [
                  'The requesting employee must secure prior approval through email from the CUSTODIAN’s immediate superior, copy furnished to the IT Department;',
                  'The approved borrower shall be responsible for the proper use and care of the Company-Issued IT Asset during the approved borrowing period;',
                  'If the Company-Issued IT Asset is lent without proper approval, the CUSTODIAN and the borrower may be held solidarily liable for any loss, damage, misuse, data breach, or negligence involving the asset.'
                ]
              },
              'If the CUSTODIAN is reassigned, transferred, promoted, separated, resigned, terminated, retired, or disengaged from the COMPANY, the Company-Issued IT Asset and all accessories must be returned to the IT Department for inspection and clearance.',
              'If the CUSTODIAN fails to return the Company-Issued IT Asset and accessories upon demand, reassignment, or separation from employment, he/she shall be liable to pay the fair market value or book value of the asset and accessories, whichever is higher, without prejudice to other remedies available to the COMPANY.'
            ]
          }
        ]
      }
    },

    confidentialityAndDataProtectionObligationsNew () {
      return {
        stack: [
          {
            text: 'CONFIDENTIALITY AND DATA PROTECTION OBLIGATIONS',
            margin: [0, 10, 0, 0],
            fontSize: 12,
            decoration: 'underline'
          },
          {
            margin: [25, 5, 55, 0],
            type: 'lower-alpha',
            ol: [
              'The CUSTODIAN acknowledges that the Company-Issued IT Asset may contain, store, process, access, or transmit confidential, proprietary, operational, financial, employee-related, customer-related, supplier-related, and other sensitive COMPANY information.',
              'The CUSTODIAN shall maintain the confidentiality of all information accessed, stored, processed, transmitted, or handled through the Company-Issued IT Asset.',
              'The CUSTODIAN shall not copy, disclose, share, upload, transfer, email, print, publish, or make available any confidential company data to unauthorized persons, platforms, devices, or storage locations.',
              'The CUSTODIAN shall not use personal cloud storage, unauthorized external drives, personal email accounts, messaging applications, or non-approved platforms to store or transfer company files unless expressly authorized by the COMPANY.',
              'The CUSTODIAN shall immediately report to the IT Department and his/her immediate superior any suspected or actual data breach, unauthorized access, lost device, malware infection, phishing incident, compromised account, or accidental disclosure of company information.',
              'The confidentiality obligations of the CUSTODIAN shall continue even after the Company-Issued IT Asset has been returned or after the CUSTODIAN’s employment with the COMPANY has ended.',
              'Any violation of this section may subject the CUSTODIAN to administrative, disciplinary, civil, or other appropriate action, depending on the severity of the incident and applicable company policies.'
            ]
          }
        ]
      }
    },

    warrantyCoverageAndRepairCostsNew () {
      return {
        stack: [
          {
            text: 'WARRANTY COVERAGE AND REPAIR COSTS',
            margin: [0, 10, 0, 0],
            fontSize: 12,
            decoration: 'underline'
          },
          {
            margin: [25, 5, 55, 0],
            type: 'lower-alpha',
            ol: [
              'The Company-Issued IT Asset and its accessories may be covered by the manufacturer’s warranty, subject to the warranty period, warranty terms, and conditions provided by the manufacturer or authorized supplier.',
              'Warranty coverage may generally include manufacturer defects, factory defects, hardware failure under normal use, or other issues expressly covered under the official warranty terms.',
              'The IT Department shall evaluate the reported issue and determine whether the defect or damage may be covered by the manufacturer’s warranty or whether it is outside warranty coverage.',
              'If the issue is covered by warranty, the IT Department shall coordinate with the supplier, service center, or authorized repair provider for proper repair or replacement.',
              'If the repair is not covered by warranty but is due to normal wear and tear, aging, or regular use, the COMPANY may shoulder the repair or replacement cost, subject to assessment and approval.',
              'If the damage, defect, or system issue is caused by negligence, misuse, unauthorized modification, improper handling, intentional damage, unauthorized repair, removal of security controls, or violation of IT policies, the CUSTODIAN may be held liable for the repair or replacement cost.'
            ]
          }
        ]
      }
    },

    repairsNotCoveredByWarrantyNew () {
      return {
        stack: [
          {
            text: 'REPAIRS NOT COVERED BY WARRANTY',
            margin: [0, 10, 0, 0],
            fontSize: 12,
            decoration: 'underline'
          },
          {
            text: [
              'The following may be considered outside the scope of manufacturer’s warranty, subject to: ',
              'actual assessment by the IT Department, supplier, or authorized service center'
            ],
            margin: [0, 10, 55, 10]
          },
          {
            margin: [25, 5, 55, 0],
            type: 'lower-alpha',
            ol: [
              'Physical damage caused by dropping, impact, mishandling, pressure, or improper storage;',
              'Liquid damage or exposure to moisture, rain, flooding, or other harmful substances;',
              'Damage caused by fire, extreme heat, electrical surge, improper charging, or use of unauthorized chargers or accessories;',
              'Damage caused by unauthorized repair, opening, tampering, modification, rooting, jailbreaking, or replacement of parts;',
              'Software issues caused by unauthorized applications, malware, piracy, cracked software, prohibited downloads, or unsafe browsing;',
              'Loss, theft, or disappearance of the Company-Issued IT Asset or accessories;',
              'Broken screen, damaged keyboard, damaged ports, damaged hinges, damaged casing, missing parts, damaged camera, damaged buttons, damaged touch screen, or similar damage caused by misuse or negligence;',
              'Data loss, file corruption, or deleted files caused by user action, failure to back up files, unauthorized software installation, or unauthorized modification;',
              'Damage or malfunction caused by removing, disabling, bypassing, or tampering with company-installed security software, endpoint protection, mobile device management, or other administrative controls;',
              'Any other damage or defect declared by the manufacturer, supplier, authorized service center, or IT Department as outside warranty coverage.'
            ]
          }
        ]
      }
    },

    lossTheftOrDamageNew () {
      return {
        stack: [
          {
            text: 'LOSS, THEFT, OR DAMAGE',
            margin: [0, 10, 0, 0],
            fontSize: 12,
            decoration: 'underline'
          },
          {
            text: [
              'In case of loss, theft, or damage of the Company-Issued IT Asset and/or its accessories, the CUSTODIAN shall comply with the following: '
            ],
            margin: [0, 10, 55, 10]
          },
          {
            margin: [25, 5, 55, 0],
            type: 'lower-alpha',
            ol: [
              {
                text: [

                  'Notify his/her immediate superior and the IT Department within ',
                  {
                    text: 'twenty-four (24) hours ',
                    bold: true
                  },
                  'from discovery of the incident.'
                ]
              },
              {
                text: [
                  'Submit an incident report and/or police blotter, whichever is deemed necessary, to the HR Department, copy furnished to the IT Department, within the next ',
                  {
                    text: 'forty-eight (48) hours',
                    bold: true
                  },
                  '.'
                ]
              },
              'The report must clearly state the date, time, place, cause, surrounding circumstances, and actions taken regarding the loss, theft, or damage.',
              'Failure to provide timely notification and required report may make the CUSTODIAN liable for the full replacement value of the Company-Issued IT Asset and accessories.',
              'The IT Department, together with the appropriate department/s, shall assess the incident and determine whether the loss, theft, or damage was caused by ordinary wear and tear, force majeure, negligence, omission, misuse, or intentional act.',
              'If the incident is found to be caused by negligence, omission, misuse, or intentional act of the CUSTODIAN, the CUSTODIAN shall be liable in accordance with Section IX of this Agreement.'
            ]
          }
        ]
      }
    },

    rolesAndResponsibilitiesOfTheCompanyNew () {
      return {
        stack: [
          {
            text: 'ROLES AND RESPONSIBILITIES OF THE COMPANY',
            margin: [0, 10, 0, 0],
            fontSize: 12,
            decoration: 'underline'
          },
          {
            margin: [25, 5, 55, 0],
            type: 'lower-alpha',
            ol: [
              'The COMPANY, through the IT Department, shall manage the issuance, monitoring, maintenance, and control of the Company-Issued IT Asset and its accessories.',
              'The IT Department shall be responsible for the procurement, inventory tagging, documentation, and deployment of Company-Issued IT Assets and accessories.',
              'The IT Department shall provide the CUSTODIAN with basic care, usage, security, and handling instructions prior to or upon issuance of the Company-Issued IT Asset.',
              'The IT Department shall maintain and update the status of the Company-Issued IT Asset in the IT Asset Management System or other official asset monitoring system.',
              'The IT Department shall keep a record of the issued asset, assigned custodian, serial number, specifications, warranty status, repair history, and return status.',
              'The IT Department shall follow established technical support protocols to ensure that reported issues are properly assessed and addressed.',
              'The IT Department shall manage administrative access, security controls, system restrictions, endpoint protection, mobile device management, and other security features necessary to protect the best interests of the COMPANY.',
              'The IT Department shall determine whether reported issues are covered by warranty, subject to normal wear and tear, or caused by negligence, misuse, unauthorized modification, or intentional damage.',
              'The COMPANY shall furnish copies of this Agreement to the proper departments and records custodians. This Agreement shall be printed in four (4) copies to be kept by the Legal Counsel, Legal Officer, IT Department, and the Employee 201 File.'
            ]
          }
        ]
      }
    },

    sanctionForTheNegligenceOfCustodianNew () {
      return {
        stack: [
          {
            text: 'SANCTION FOR NEGLIGENCE OR OMISSION OF THE CUSTODIAN',
            margin: [0, 10, 0, 0],
            decoration: 'underline'
          },
          {
            text: [
              'If the Company-Issued IT Asset is lost, stolen, totally damaged, or rendered unusable due to ',
              'the negligence, omission, misuse, or intentional act of the CUSTODIAN, the CUSTODIAN shall be liable based on the acquisition cost or purchase value of the asset, as follows:'
            ],
            margin: [0, 10, 55, 10]
          },
          {
            margin: [25, 5, 55, 0],
            type: 'lower-alpha',
            ol: [
              {
                text: [
                  'If within one (1) year from issuance, ',
                  {
                    text: 'seventy-five percent (75%) ',
                    bold: true
                  },
                  'of the purchase value shall be charged to the CUSTODIAN;'
                ]
              },
              {
                text: [
                  'If within two (2) years from issuance, ',
                  {
                    text: 'fifty percent (50%) ',
                    bold: true
                  },
                  'of the purchase value shall be charged to the CUSTODIAN;'
                ]
              },
              {
                text: [
                  'If within three (3) years from issuance, ',
                  {
                    text: 'twenty-five percent (25%) ',
                    bold: true
                  },
                  'of the purchase value shall be charged to the CUSTODIAN;'
                ]
              },
              {
                text: [
                  'If more than three (3) years from issuance, ',
                  {
                    text: 'fifteen percent (15%) ',
                    bold: true
                  },
                  'of the purchase value shall be charged to the CUSTODIAN;'
                ]
              }
            ]
          },
          {
            text: [
              'For partial damage caused by negligence, omission, misuse, unauthorized modification, ',
              'or intentional act, the CUSTODIAN shall be liable for the full cost of repair or replacement of the damaged part/s, subject to assessment by the IT Department.'
            ],
            margin: [0, 10, 55, 10]
          }
        ]
      }
    },

    returnReassignmentOrReplacementOfCompanyIssuedITAssetNew () {
      return {
        stack: [
          {
            text: 'RETURN, REASSIGNMENT, OR REPLACEMENT OF COMPANY-ISSUED IT ASSET',
            margin: [0, 10, 0, 0],
            fontSize: 12,
            decoration: 'underline'
          },
          {
            margin: [25, 5, 55, 0],
            type: 'lower-alpha',
            ol: [
              'The Company-Issued IT Asset and all accessories must be returned to the IT Department upon resignation, retirement, termination, transfer, reassignment, disengagement, or upon demand by the COMPANY.',
              'If the CUSTODIAN is transferred to another position, department, or unit, the IT Department shall assess whether the asset specifications remain compatible with the new work assignment.',
              'Depending on the assessment, the IT Department may recommend continued use, replacement, return, reassignment, or issuance of a new IT asset.',
              'If a new Company-Issued IT Asset is issued, a new Memorandum of Agreement may be executed, unless only an update of the working status or custodian record is necessary.',
              'The Company-Issued IT Asset may only be awarded, donated, or transferred to the CUSTODIAN if supported by an approved written authorization from the COMPANY.'
            ]
          }
        ]
      }
    },

    rescissionOfAgreementNew () {
      return {
        stack: [
          {
            text: 'RESCISSION OF AGREEMENT',
            margin: [0, 10, 0, 0],
            fontSize: 12,
            decoration: 'underline'
          },
          {
            margin: [25, 5, 55, 0],
            type: 'lower-alpha',
            ol: [
              'The COMPANY, being the owner of the Company-Issued IT Asset and its accessories, shall have full discretion to cancel, rescind, amend, recall, or terminate this Agreement at any time when deemed necessary.',
              'The COMPANY shall be free from liability arising from the acts, omissions, negligence, misuse, unauthorized acts, or violations committed by the CUSTODIAN, except for losses or damages caused by force majeure or circumstances not attributable to the CUSTODIAN.'
            ]
          }
        ]
      }
    },

    entireAggreementNew () {
      return {
        headlineLevel: 1,
        stack: [
          {
            text: 'ENTIRE AGREEMENT',
            margin: [0, 10, 0, 0],
            fontSize: 12,
            decoration: 'underline'
          }
        ]
      }
    },

    approversNew () {
      return {
        stack: [
          {
            text: [
              'This Agreement contains the entire understanding of the PARTIES relating to the subject matter hereof and supersedes all prior communications, representations, or agreements, whether verbal or written.'
            ],
            margin: [0, 10, 55, 0]
          },
          {
            text: [
              'This Agreement may not be altered, amended, modified, or otherwise changed, and no provision hereof may be waived, except through a written instrument signed by both PARTIES or by the authorized representative of the COMPANY.'
            ],
            margin: [0, 10, 55, 0]
          },
          {
            alignment: 'justify',
            margin: [0, 30, 0, 0],
            text: [
              {
                text: 'IN WITNESS WHEREOF',
                bold: true
              },
              ', the PARTIES have caused this Agreement to be executed this ',
              {
                text: '                                              ',
                decoration: 'underline'
              }
            ]
          },
          {
            alignment: 'justify',
            text: [
              ' day of ',
              {
                text: '                                              ',
                decoration: 'underline'
              },
              ', ',
              {
                text: '2026',
                bold: true
              },
              ' at Purok Maligaya, Batal, Santiago City.'
            ]
          },
          this.signatoriesOneNew(),
          {
            text: 'SIGNED IN THE PRESENCE OF',
            alignment: 'center',
            margin: [0, 0, 55, 10]
          },
          this.signatoriesTwoNew()
        ]
      }
    },

    signatoriesOneNew () {
      return {
        margin: [0, 30, 55, 10],
        table: {
          layout: 'noBorders',
          widths: ['50%', '50%'],
          body: [
            [
              {
                stack: [
                  {
                    text: 'JOSHUA V. VALLE, CPA',
                    bold: true
                  },
                  {
                    canvas: [
                      {
                        type: 'line',
                        x1: 200,
                        x2: 0,
                        y1: 1,
                        y2: 1,
                        lineWidth: 1
                      }
                    ]
                  },
                  {
                    text: 'ACCOUNTING MANAGER',
                    margin: [0, 5, 0, 0]
                  }
                ],
                alignment: 'center',
                border: [false, false, false, false]
              },
              {
                stack: [
                  {
                    text: (`${this.employeeContract.first_name} ${this.employeeContract?.middle_name || ''} ${this.employeeContract.last_name} ${this.employeeContract?.suffix_name || ''}`).toLowerCase().toUpperCase(),
                    bold: true
                  },
                  {
                    canvas: [
                      {
                        type: 'line',
                        x1: 200,
                        x2: 0,
                        y1: 1,
                        y2: 1,
                        lineWidth: 1
                      }
                    ]
                  },
                  {
                    text: 'EMPLOYEE',
                    margin: [0, 5, 0, 0]
                  }
                ],
                alignment: 'center',
                border: [false, false, false, false]
              }
            ]
          ]
        }
      }
    },

    signatoriesTwoNew () {
      return {
        margin: [0, 0, 55, 0],
        table: {
          layout: 'noBorders',
          widths: ['50%', '50%'],
          body: [
            [
              {
                stack: [
                  {
                    text: 'HARVIE A. BAÑARES',
                    bold: true
                  },
                  {
                    canvas: [
                      {
                        type: 'line',
                        x1: 200,
                        x2: 0,
                        y1: 1,
                        y2: 1,
                        lineWidth: 1
                      }
                    ]
                  },
                  {
                    text: 'TECHNOLOGY ENABLEMENT SUPERVISOR',
                    margin: [0, 5, 0, 0]
                  }
                ],
                alignment: 'center',
                border: [false, false, false, false]
              },
              {
                stack: [
                  {
                    text: ' ',
                    bold: true
                  },
                  {
                    canvas: [
                      {
                        type: 'line',
                        x1: 200,
                        x2: 0,
                        y1: 1,
                        y2: 1,
                        lineWidth: 1
                      }
                    ]
                  }
                ],
                alignment: 'center',
                border: [false, false, false, false]
              }
            ]
          ]
        }
      }
    }
  }
}
